import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = {
  key: 0,
  class: "container is-tp-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title is-2" }, "Log Records", -1)
const _hoisted_4 = {
  key: 1,
  class: "container is-tp-container",
  "data-text": "error-permissions"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "title is-2" }, "You don't have the required permissions to read Logs", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TPDataGridApi = _resolveComponent("TPDataGridApi")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.allowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_TPDataGridApi, {
            config: _ctx.configDataGrid,
            class: "mt-5"
          }, null, 8, ["config"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
  ]))
}